import { useQueryClient } from '@tanstack/react-query';
import useMutationApi from 'src/api/useMutationApi';

interface DeleteWatchRequest {
  watchableEntityType: string;
  watchableId: string;
  watchId: string;
}

const useDeleteWatch = ({
  watchableEntityType,
  watchableId,
  watchId,
}: DeleteWatchRequest) => {
  const queryClient = useQueryClient();

  return useMutationApi<DeleteWatchRequest>({
    endpoint: `core/watches/${watchId}`,
    method: 'DELETE',
    options: {
      onSuccess: () => {
        // Invalidate the watchers query to refetch the data
        queryClient.invalidateQueries({
          queryKey: [`core/watches/${watchableEntityType}/${watchableId}`],
        });
      },
    },
  });
};

export default useDeleteWatch;
